import axios from 'axios';

const ajaxUrl = '/wp-admin/admin-ajax.php';

export default function loadMoreEvents() {
    const eventTabSlider = document.querySelector('.js-event-wrap');

    if (!eventTabSlider) {
        return;
    }

    const button = eventTabSlider.querySelector('.js-load-events');
    const eventList = eventTabSlider.querySelector('.js-event-list');

    if (!button) {
        return;
    }

    const {category} = button.dataset;
    const total = parseInt(button.dataset.total, 10);
    let page = parseInt(button.dataset.paged, 10);

    const handleButtonClick = () => {
        if (page === total) {
            return;
        }

        page += 1;
        button.disabled = true;

        const data = new URLSearchParams({
            action: 'get_ajax_posts_events',
            page,
            category,
        });

        axios.post(ajaxUrl, data)
            .then(response => response.data)
            .then((html) => {
                eventList.insertAdjacentHTML('beforeend', html);
                button.disabled = false;

                if (page === total) {
                    button.removeEventListener('click', handleButtonClick);
                    button.parentNode.removeChild(button);
                }
            });
    };

    button.addEventListener('click', handleButtonClick, false);
}
window.addEventListener('load', loadMoreEvents);
